import { Flex } from 'foundations-components/components/Flex';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { ErrorPageContent } from '../components/common/error/ErrorPageContent';
import { DEFAULT } from '../constants/ErrorCauses';
import { SCREENS } from '../constants/tracking/Screens';
import { Metrics } from '../utils/metrics';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ErrorPage({
  errorCause = DEFAULT,
  additionalErrorLogging = {}
}) {
  useEffect(() => {
    console.error(`ErrorPage visited with error cause: ${errorCause}`);
    trackPageView({
      screen: SCREENS.ERROR
    });
    Metrics.counter('error-page-visited', {
      errorType: errorCause
    }).increment();
    Raven.captureMessage(`ErrorPage visited with error cause: ${errorCause}`, {
      extra: additionalErrorLogging
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    padding: "1000",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "ERROR_PAGE"
    }), /*#__PURE__*/_jsx(ErrorPageContent, {
      errorCause: errorCause
    })]
  });
}
export default ErrorPage;